"use client"

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react"
import { ActivityTracker } from "@/components/session/ActivityTracker"

export function SessionProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextAuthSessionProvider>
      {children}
      {/* La deconnexion apres 15 minutes d'inactivite (CNX) */}
      <ActivityTracker />
    </NextAuthSessionProvider>
  )
}
